<template>
  <b-modal id="modal-home-ad"
           content-class="md_inner_modal"
           header-class="popup_header1"
           body-class="modal-home-ad-body"
           :visible="visible"
           @hidden="onCancel();"
           @show="onShow"
           hide-header hide-footer centered>
    <div>
      <b-carousel
        ref="ads_carousel"
        v-if="adsList.length > 0"
        indicators
        controls
        id="carousel"
        :interval="homeSetting.f_ads_mode == 'S' ? homeSetting.f_ads_duration_sec * 1000 : 0"
        class="carousel_wrapper"
        v-model="activeIndex"
        @sliding-end="onSlideEnd"
      >
        <b-carousel-slide
          v-for="item in adsList"
          class="slide-item"
        >
          <template slot="img">
            <b-img
              style="height: 100%; width: 100% !important; cursor:pointer;"
              :src="item.f_image_url"
              @mousedown="slideDown"
              @mouseup="(e) => slideUp(e, item)"
            />
          </template>
        </b-carousel-slide>
      </b-carousel>
    </div>
    <hr style="margin-top: 0.5rem;margin-bottom: 0.5rem">
    <div>
      <b-row>
        <b-col cols="7" style="padding-top: 0.3rem;">
          <b-form-checkbox
            id="home-ad-popup-checkbox"
            v-model="isTodayNoAd"
            value="true"
            style="font-family: 'KoreanGD14R';"
            @change="onCancel"
            unchecked-value="false">
            &nbsp;&nbsp;8시간 동안 보지 않기
          </b-form-checkbox>
        </b-col>
        <b-col cols="5" style="text-align: right">
          <b-button class="btn_label" variant="white" @click="onCancel" style="padding-top: 0.3rem;">
            <img class="dlg_close_btn" src="../../../assets/image/ic_close2.png"
                 style="width: 0.7rem; height: 0.7rem; display: inline; vertical-align: middle;">&nbsp;&nbsp;<span style="font-family: 'KoreanGD14R';">닫기</span>
          </b-button>
        </b-col>
      </b-row>

    </div>

    <Gallery
      :src="imgList"
      :current="activeIndex"
      :visible.sync="showGallery"
    />
  </b-modal>
</template>

<script>
import Utils from '../../../config/utils'
import MdSingleCheckBox from "../mf/MdSingleCheckBox.vue";
import Gallery from "../Gallery.vue";
import CCarousel from "../CCarousel.vue";
const utils = require('util');
export default {
  name: "HomeAdPopup",
  components: {MdSingleCheckBox, Gallery, CCarousel},
  props:["visible", "homeSetting", "adsList", "onSiteDetail", "onCommunityDetail"],
  data() {
    return {
      self: this,
      u: Utils,
      ut: utils,
      activeIndex: 0,
      offset:0,
      showGallery:false,
      imgList:[],
      isTodayNoAd:false
    }
  },
  mounted() {
  },
  methods:{
    onSlideEnd(slide) {
      if (this.homeSetting.f_ads_mode == 'R'){
        clearInterval(this.ads_interval);
        this.timer();
      }
    },
    onShow() {
      this.isTodayNoAd = false;
      this.activeIndex = this.homeSetting.f_ads_mode == 'R' ? Math.ceil(Math.random() * this.adsList.length): 0;
      this.randomSlideShowAdsImages();
    },
    onCancel()  {
      clearInterval(this.ads_interval);
      if (this.isTodayNoAd) {
        this.$perf.setString('homeAdDate', this.u.getTimeAfter8Hour());
        this.$emit('adTime', false);
      }
      this.$emit('update:visible', false);
    },
    slideDown(e){
      e.preventDefault();
      this.offset = e.offsetX;
    },
    slideUp(e, item){
      if (this.offset < e.offsetX)
        this.$refs.ads_carousel.prev();
      if (this.offset > e.offsetX)
        this.$refs.ads_carousel.next();
      if (this.offset == e.offsetX)
        this.onADS(item);
    },


    onADS(item){
      switch (item.f_connect_type) {
        case 'S':
          this.go2SiteDetail(item.f_connect_value);
          break;
        case 'C':
          Utils.requestGet(this.$c.API.Community.getCommunityDetail, {
            community_idx: item.f_connect_value,
          }).then((result) => {
            if (result.code == this.$c.API_RES_CODE.SUCCESS) {
              // this.communityData = result.data;
              // this.showCommunityDetailPopup = true;
              this.onCommunityDetail(result.data)
            } else {
              Utils.toast(this, result.msg);
            }
          });
          break;
        case 'I':
          if (!item.f_connect_value.startsWith('http')) {
            item.f_connect_value = 'http://' + item.f_connect_value;
          }
          this.imgList = [item.f_connect_value];
          this.showGallery = true;
          break;
        case 'L':
          if (!item.f_connect_value.startsWith('http')) {
            item.f_connect_value = 'http://' + item.f_connect_value;
          }
          Utils.openURL(item.f_connect_value);
          break;
      }
    },



    go2SiteDetail(siteIdx){
      Utils.requestGet(
        this.$c.API.Site.getSiteDetail,
        {
          site_idx: siteIdx,
        },
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          // this.siteDetailData = result.data;
          // this.showSiteDetailPopup = true;
          this.onSiteDetail(result.data);
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    randomSlideShowAdsImages() {
      if (this.homeSetting.f_ads_mode == 'R'){
        this.timer();
      }
    },

    timer() {
      this.ads_interval = setInterval(() => {
          let tmpIdx = Math.ceil(Math.random() * this.adsList.length);
          if (this.activeIndex === tmpIdx) {
            if (tmpIdx >= this.adsList.length - 1) {
              this.activeIndex = 0;
            } else {
              this.activeIndex = tmpIdx + 1;
            }
          } else {
            this.activeIndex = tmpIdx;
          }
        }, this.homeSetting.f_ads_duration_sec * 1000);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/Modal.scss";

.btn_label {
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/controls/popup/HomeAdPopup.vue